import { createWebHistory, createRouter } from "vue-router";
import GerenciamentoInscricoes from "@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/GerenciamentoInscricoes.vue";
import Inscricao from "@/views/Inscricao/Inscricao.vue";
import InscricaoParticipante from "@/views/InscricaoParticipante/InscricaoParticipante.vue";
import axios from 'axios';
import VisualizadorReports from "@/views/Utilidades/Visualizador_Reports.vue"
import Oficina from "@/views/Oficina/Oficina.vue";

const routes = [
    {
        path: "/inscricao",
        name: "inscricao",
        component: Inscricao,
    },
    {
        path: "/Visualizador_Reports",
        name: "Visualizador_Reports",
        component: VisualizadorReports
    },
    {
        path: "/inscricaoparticipante",
        name: "inscricaoparticipante",
        component: InscricaoParticipante,
    },
    {
        path: "/gerenciamentoinscricoes",
        name: "gerenciamentoinscricoes",
        component: GerenciamentoInscricoes,
    },
    {
        path: "/oficina",
        name: "oficina",
        component: Oficina,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    var loggedIn = localStorage.getItem('user_eventos');

    if (to.path == '/validate') {

        var url = to.query['url'];

        if (loggedIn) {
            next(url);
        }
        else {
            var dsHash = to.query['dsHash'];

            localStorage.removeItem('dsHash');
            localStorage.removeItem('user_eventos');

            axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/auth/signin?dsHash=' + dsHash, {
            })
                .catch(function (error) {
                    next('/');
                })
                .then(response => {
                    if (response.data.bearerToken) {
                        localStorage.setItem('dsHash', JSON.stringify(dsHash));
                        localStorage.setItem('user_eventos', JSON.stringify(response.data.bearerToken));
                        next(url);
                    }
                });
        }
    } else {
        if (to.path === '/inscricao' || to.path === '/inscricaoparticipante' || to.path === '/oficina') {
            next();
        } else {
            if (loggedIn) {
                next();
            } else {
                window.location = process.env.VUE_APP_ROOT_AUTENTICACAO_WEB;
            }
        }
    }
});

export default router;